var map = {
	"./analytics.png": "3440",
	"./aws.png": "d876",
	"./barbastro.png": "7bf2",
	"./gesa.png": "add6",
	"./graph-en.png": "583d",
	"./graph-es.png": "fa97",
	"./knq.png": "f836",
	"./logo.png": "9d64",
	"./madrid.jpg": "13df",
	"./seklab.jpg": "d43e",
	"./simo.jpg": "8830",
	"./slide03bullet01.png": "93f4",
	"./slide03bullet02.png": "0832",
	"./slide03bullet03.png": "8b4d",
	"./technology.png": "dd01",
	"./work01.png": "75f7",
	"./work02.png": "c95f",
	"./work03.png": "f04a",
	"./work04.png": "b633",
	"./work05.png": "42b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";